export default class bootstrapToolTip{
   init($parentElement = $(document)){
     // Configure tooltips on the parent element and use the selector option so that dynamically-added elements
     // have tooltips without needing to be initialized manually.
     // See https://github.com/twbs/bootstrap/issues/4215 and https://codepen.io/Johann-S/pen/djJYPb

     // @ts-ignore
     $parentElement.tooltip?.({
       selector: '[data-toggle="tooltip"]',
       html: true,
     });
   }
}

const bootstrapTooltip = new bootstrapToolTip();

$(()=>{bootstrapTooltip.init()});